import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'replaceText',
  standalone: false,
})
export class ReplaceTextPipe implements PipeTransform {
  transform(value: string): string {
    let regex = /\n/gi;
    return value.replace(regex, '<br/><br/>');
  }
}
